/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ErrorOutput.vue?vue&type=template&id=2ee0a375"
import script from "./ErrorOutput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorOutput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ErrorOutput.vue?vue&type=style&index=0&id=2ee0a375&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports